angular.module('aprima-legacy-common').factory('LogInService',['DeviceSettings',
    function (DeviceSettings) {
        'use strict';

        var redirectState, redirectParams, isCustomRedirect, customTransition;

        function setDefaultRedirect(){
            isCustomRedirect = false;

            if(!DeviceSettings.isDevice){
                redirectState = 'landing';
            }
            else{
                redirectState = 'dashboard';
            }

            redirectParams = null;
        }

        setDefaultRedirect();

        function setRedirect(transition){
            isCustomRedirect = true;
            customTransition = transition;

            customTransition.opts.replaceCurrentState = true;
        }

        function getRedirectTransition(){
            if(isCustomRedirect){
                return customTransition;
            }

            var redirect = {
                appRoute: redirectState,
                opts: redirectParams || {}
            };
                
            redirect.opts.replaceCurrentState = true;

            return redirect;
        }

        return {
            getRedirect: getRedirectTransition,
            setDefaultRedirect: setDefaultRedirect,
            setRedirect: setRedirect
        };
    }]);
